import React, { useEffect, useState, useContext } from "react";
// Componentes
import AñadirImagenForm from "./formularios/FormAñadirImagen";
import Galeria from "../../generic/Galeria";
// Contexto
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ModalContext } from "../../../context/modalContext";
// jquery
import $ from "jquery";
// React Bootstrap
import { Button } from "react-bootstrap";
// Utils
import { objectToFormData, removeEmptyFields, compressImages } from "../../../utils";

const MisionGaleria = ({ idProvincia, idMision, loading, setLoading, permisoEdicion, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Imágenes de la misión
  const [images, setImages] = useState([]);

  // UEF para obtener las imágenes de la misión
  useEffect(() => {
    handleGetImagenesMision();
  }, []);

  //********************************************** REQUESTS ****************************************************
  //------------------------------------------------ GET -------------------------------------------------------
  // Obtiene todas las imagenes de la misión
  const getImagenesMision = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/documentos?type=Image`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ POST -------------------------------------------------------
  // Añadir foto mision
  const postImagenMision = (data) => {
    // El tipo de documento
    data.type = "Image";
    data = objectToFormData(data);
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/documentos?type=Image`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      contentType: false,
      data: data,
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ DELETE -------------------------------------------------------
  // Borrar foto mision
  const deleteImagenMision = (idDocumento) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/documentos/${idDocumento}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };
  //********************************************** HANDLERS ****************************************************/
  //------------------------------------------------ GET -------------------------------------------------------
  // Manejador para obtener las fotos de la misión
  const handleGetImagenesMision = () => {
    setLoading(true);
    getImagenesMision()
      .then((response) => {
        let imgArray = [];
        response.items.forEach((image) => {
          imgArray.push({
            id: image.id,
            name: image.name,
            description: image.description,
            src: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${image.missionId}/documentos/${image.id}`,
          });
        });
        setImages(imgArray);
        setLoading(false);
      })
      .catch(() => {
        // props?.ErrorHandling();
        setLoading(false);
      });
  };

  //------------------------------------------------ POST -------------------------------------------------------

  // Manejador para el post de la imagen de una misión
  const handlePostImage = async (data) => {
    setLoading(true);
    modalSetShow(false);
    removeEmptyFields(data);

    // Comprimimos la imagen
    let files = data.file;
    let compImg = true;
    // Si hay imagenes
    if (files.length) {
      compImg = await compressImages(files);
      // Si todo es correcto sustituimos las imagenes por las comprimidas
      if (compImg) {
        data.file = compImg;
      } else {
        // Ponemos un error. El error se limpia solo cuando resubimos el campo
        addAlert("Error", "Error comprimiendo la imagen", "danger");
      }
    }
    // Si se ha comprimido bien la imagen hacemos la petición
    if (compImg)
      postImagenMision(data)
        .then(() => {
          setLoading(false);
          handleGetImagenesMision();
          addAlert("Exito", "Se ha añadido la imagen correctamente", "success");
        })
        .catch(() => {
          setLoading(false);
          addAlert("Error", "No se ha podido añadir correctamente la imagen", "danger");
        });
  };

  //------------------------------------------------ DELETE -------------------------------------------------------
  // Manejador para el delete de la imagen de una misión
  const handleDeleteImage = (idDocumento) => {
    setLoading(true);
    deleteImagenMision(idDocumento)
      .then((response) => {
        setLoading(false);
        handleGetImagenesMision();
        addAlert("Exito", "Se ha borrado la imagen correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
        // addAlert("Error", "No se ha podido añadir correctamente la imagen", "danger");
      });
  };

  //************************************************ RETURN *****************************************************/
  return (
    <div>
      <h3>Galería</h3>
      <Galeria deleteFunction={handleDeleteImage} images={images} {...props} />
      {permisoEdicion && <Button
        onClick={() => {
          modalSetShow(true);
          modalSetTitle("Añadiendo foto misión");
          modalSetContent(<AñadirImagenForm submissionHandler={handlePostImage} />);
        }}
        className="d-flex ml-auto btn btn-outline-secondary"
      >
        Añadir imagen a la galería
      </Button>}
    </div>
  );
};

export default MisionGaleria;
